import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '@/assets/LOGO.svg';
import hold from '@/assets/select.png';
import nohold from '@/assets/pricing/nohold.png';
import './Pricing.less';
import { getToken } from '@/utils/cookie';
import Icon from '@/components/iconfont/Icon.jsx';
import { infoController, userService } from '@/api/index';
import { useDrawer } from '@/hooks/DrawerHooks';
import { useWebSocket } from '@/hooks/useWebSocket.js';
import { MessageEventType } from '@/utils/socket.js';
// import SentryTracker from '@/utils/Sentry/sentryUtils';
import message from '@/utils/message';
export default function Pricing() {
  const mean = ['As_Pricing_Term1', 'As_Pricing_Term2', 'As_Pricing_Term3'];
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [token, setToken] = useState('');
  const [userData, setUserData] = useState({});
  const [pricingChecked, setPricingChecked] = useState(1);
  const [textlist, setTextList] = useState([]);
  const [fuelbags, setfuelbags] = useState([]);
  const sub_info = [
    {
      level: 'As_Pricing_Plan1',
      creditCanBeUsedFor: [
        'As_Pricing_StandardInclude',
        'As_Pricing_NewStandBene1',
        'As_Pricing_NewStandBene2',
        'As_Pricing_NewStandBene3',
        'As_Pricing_NewStandBene4',
        'As_Pricing_NewStandBene5',
        'As_Pricing_NewStandBene6',
        'As_Pricing_NewStandBene7',
      ],
      equityDetails: [
        'As_Pricing_CreditsFor',
        'As_Pricing_StandUsage1',
        'As_Pricing_StandUsage2',
        'As_Pricing_StandUsage3',
        'As_Pricing_StandUsage4',
        'As_Pricing_StandUsage5',
      ],
    },
    {
      level: 'As_Pricing_Plan2',
      creditCanBeUsedFor: [
        'As_Pricing_StarterInclude',
        'As_Pricing_NewStarterBene1',
        'As_Pricing_NewStarterBene2',
        'As_Pricing_NewStarterBene3',
        'As_Pricing_NewStarterBene4',
        'As_Pricing_NewStarterBene5',
        // 'As_Pricing_NewStarterBene6',
        // 'As_Pricing_NewStarterBene7',
      ],
      equityDetails: [
        'As_Pricing_CreditsFor',
        'As_Pricing_StarterUsage1',
        'As_Pricing_StarterUsage2',
        'As_Pricing_StarterUsage3',
        'As_Pricing_StarterUsage4',
        'As_Pricing_StarterUsage5',
      ],
    },
    {
      level: 'As_Pricing_Plan3',
      creditCanBeUsedFor: [
        'As_Pricing_CreatorInclude',
        'As_Pricing_NewCreatorBene1',
        'As_Pricing_NewCreatorBene2',
        'As_Pricing_NewCreatorBene3',
        // 'As_Pricing_NewCreatorBene4',
        // 'As_Pricing_NewCreatorBene5',
        // 'As_Pricing_NewCreatorBene6',
        // 'As_Pricing_NewCreatorBene7',
      ],
      equityDetails: [
        'As_Pricing_CreditsFor',
        'As_Pricing_CreatorUsage1',
        'As_Pricing_CreatorUsage2',
        'As_Pricing_CreatorUsage3',
        'As_Pricing_CreatorUsage4',
        'As_Pricing_CreatorUsage5',
      ],
    },
    {
      level: 'As_Pricing_Plan4',
      creditCanBeUsedFor: [
        'As_Pricing_EnterpriseInclude',
        'As_Pricing_NewEnterpBene1',
        // 'As_Pricing_NewEnterpBene2',
        // 'As_Pricing_NewEnterpBene3',
        'As_Pricing_NewEnterpBene4',
        'As_Pricing_NewEnterpBene5',
        'As_Pricing_NewEnterpBene6',
        'As_Pricing_NewEnterpBene7',
      ],
      equityDetails: [
        'As_Pricing_CreditsFor',
        'As_Pricing_EnterpUsage1',
        'As_Pricing_EnterpUsage2',
        'As_Pricing_EnterpUsage3',
        'As_Pricing_EnterpUsage4',
        'As_Pricing_EnterpUsage5',
      ],
    },
  ];
  const fuelbag_info = [
    [
      'As_Pricing_CreditsInclude',
      'As_Pricing_Credits1Bene1',
      'As_Pricing_Credits1Bene2',
      'As_Pricing_Credits1Bene3',
      'As_Pricing_Credits1Bene4',
      'As_Pricing_Credits1Bene5',
    ],
    [
      'As_Pricing_CreditsInclude',
      'As_Pricing_Credits2Bene1',
      'As_Pricing_Credits2Bene2',
      'As_Pricing_Credits2Bene3',
      'As_Pricing_Credits2Bene4',
      'As_Pricing_Credits2Bene5',
    ],
    [
      'As_Pricing_CreditsInclude',
      'As_Pricing_Credits3Bene1',
      'As_Pricing_Credits3Bene2',
      'As_Pricing_Credits3Bene3',
      'As_Pricing_Credits3Bene4',
      'As_Pricing_Credits3Bene5',
    ],
  ];

  const features_table = [
    [
      { type: 0, value: 'As_Pricing_CompareBene1' },
      { type: 1, value: hold },
      { type: 1, value: hold },
      { type: 1, value: hold },
      { type: 1, value: hold },
    ],
    [
      { type: 0, value: 'As_Pricing_CompareBene2' },
      { type: 1, value: hold },
      { type: 1, value: hold },
      { type: 1, value: hold },
      { type: 1, value: hold },
    ],
    [
      { type: 0, value: 'As_Pricing_CompareBene3' },
      { type: 1, value: nohold },
      { type: 1, value: hold },
      { type: 1, value: hold },
      { type: 1, value: hold },
    ],
    [
      { type: 0, value: 'As_Pricing_CompareBene4' },
      { type: 0, value: 'As_Pricing_CompareStand4' },
      { type: 0, value: 'As_Pricing_CompareStarter4' },
      { type: 0, value: 'As_Pricing_CompareCreator4' },
      { type: 0, value: 'As_Pricing_CompareEnterp4' },
    ],
    [
      { type: 0, value: 'As_Pricing_CompareBene5' },
      { type: 0, value: 'As_Pricing_CompareStand5' },
      { type: 0, value: 'As_Pricing_CompareStarter5' },
      { type: 0, value: 'As_Pricing_CompareCreator5' },
      { type: 0, value: 'As_Pricing_CompareEnterp5' },
    ],
    [
      { type: 0, value: 'As_Pricing_CompareBene6' },
      { type: 0, value: 'As_Pricing_CompareStand6' },
      { type: 0, value: 'As_Pricing_CompareStarter6' },
      { type: 0, value: 'As_Pricing_CompareCreator6' },
      { type: 0, value: 'As_Pricing_CompareEnterp6' },
    ],
    [
      { type: 0, value: 'As_Pricing_CompareBene7' },
      { type: 0, value: 'As_Pricing_CompareStand7' },
      { type: 0, value: 'As_Pricing_CompareStarter7' },
      { type: 0, value: 'As_Pricing_CompareCreator7' },
      { type: 0, value: 'As_Pricing_CompareEnterp7' },
    ],
    [
      { type: 0, value: 'As_Pricing_CompareBene8' },
      { type: 0, value: 'As_Pricing_CompareStand8' },
      { type: 0, value: 'As_Pricing_CompareStarter8' },
      { type: 0, value: 'As_Pricing_CompareCreator8' },
      { type: 0, value: 'As_Pricing_CompareEnterp8' },
    ],
    [
      { type: 0, value: 'As_Pricing_CompareBene9' },
      { type: 0, value: 'As_Pricing_CompareStand9' },
      { type: 0, value: 'As_Pricing_CompareStarter9' },
      { type: 0, value: 'As_Pricing_CompareCreator9' },
      { type: 0, value: 'As_Pricing_CompareEnterp9' },
    ],
    [
      { type: 0, value: 'As_Pricing_CompareBene10' },
      { type: 0, value: 'As_Pricing_CompareStand10' },
      { type: 0, value: 'As_Pricing_CompareStarter10' },
      { type: 0, value: 'As_Pricing_CompareCreator10' },
      { type: 0, value: 'As_Pricing_CompareEnterp10' },
    ],
    [
      { type: 0, value: 'As_Pricing_CompareBene11' },
      { type: 1, value: nohold },
      { type: 1, value: nohold },
      { type: 1, value: nohold },
      { type: 1, value: hold },
    ],
    [
      { type: 0, value: 'As_Pricing_CompareBene12' },
      { type: 1, value: nohold },
      { type: 1, value: nohold },
      { type: 1, value: nohold },
      { type: 1, value: hold },
    ],
  ];
  const { isOpen, setUpdataDetail } = useDrawer();
  useEffect(() => {
    if (new URLSearchParams(window.location.search).get('utm_source')) {
      sessionStorage.setItem(
        'source',
        new URLSearchParams(window.location.search).get('utm_source'),
      );
    }
    if (new URLSearchParams(window.location.search).get('utm_campaign')) {
      sessionStorage.setItem(
        'campaign',
        new URLSearchParams(window.location.search).get('utm_campaign'),
      );
    }
    if (new URLSearchParams(window.location.search).get('utm_term')) {
      sessionStorage.setItem('term', new URLSearchParams(window.location.search).get('utm_term'));
    }
    if (new URLSearchParams(window.location.search).get('utm_ad')) {
      sessionStorage.setItem('ad', new URLSearchParams(window.location.search).get('utm_ad'));
    }
  }, []);

  const getplansList = useCallback(async () => {
    try {
      const plans = await infoController.infoPlans();
      plans.data = plans.data.map((res) => ({ ...res, loading: false }));
      setTextList(plans.data);
    } catch (error) {
      console.log(error);
      message.error(t('As_Error_Network'), {
        id: 'only',
      });
    }
    try {
      const bags = await infoController.fuelBags();
      bags.data = bags.data.map((res) => ({ ...res, loading: false }));
      setfuelbags(bags.data);
    } catch (error) {
      console.log(error);
      message.error(t('As_Error_Network'), {
        id: 'only',
      });
    }
    if (token || isOpen) {
      try {
        const res = await userService.userDetail();
        if (res?.code === 0) {
          console.log('用户数据:', res);
          setUserData(res.data);
        }
      } catch (error) {
        console.log(error);
        message.error(t('As_Error_Network'), {
          id: 'only',
        });
      }
    }
  }, [token, isOpen]);

  useEffect(() => {
    const type = localStorage.getItem('pricing_type') || 0;
    setPricingChecked(type);
    setToken(getToken());
    localStorage.setItem('pricing_type', 0);
    if (token) {
      if (isOpen) {
        setTimeout(() => {
          getplansList();
        }, 10);
      }
    } else {
      getplansList();
    }
  }, [isOpen, token]);

  useWebSocket(
    MessageEventType.USER_LEVEL_CHANGED,
    useCallback(
      ({ orderId, price }) => {
        getplansList();
        message.success('Upgraded successfull !');
        window.onClickSubscribeSuccess({
          email: userData?.userInfo?.email,
          id: orderId,
          amount: price,
        });
        setUpdataDetail(Date.now());
      },
      [textlist],
    ),
  );

  // 付款
  const handleCheckout = async (type, order, sub_type = '') => {
    if (!getToken()) {
      navigate('/home');
      return;
    }
    const data = { type, priceId: '', subscriptionPeriod: sub_type };
    if (type == 0) {
      // 订阅
      setTextList((item) =>
        item.map((res) => {
          if (res.id == order.id) {
            res.loading = true;
          }
          return res;
        }),
      );
      data.priceId = sub_type == 1 ? order.yearlyPriceId : order.monthlyPriceId;
      if (order.id == 2) {
        window.onClickGATrackEvent('pricing-starter-upgrade');
      }
      if (order.id == 3) {
        window.onClickGATrackEvent('pricing-creator-upgrade');
      }
    } else {
      // 积分
      setfuelbags((item) =>
        item.map((res) => {
          if (res.id == order.id) {
            res.loading = true;
          }
          return res;
        }),
      );
      delete data.subscriptionPeriod;
      data.priceId = order.priceId;
    }
    try {
      const res = await infoController.checkout(data);
      window.open(res.data);
    } catch (error) {
      console.log(error);
      message.error('Payment failed, please try again', {
        id: 'only',
      });
    }

    if (type == 0) {
      setTextList((item) =>
        item.map((res) => {
          if (res.id == order.id) {
            res.loading = false;
          }
          return res;
        }),
      );
    } else {
      setfuelbags((item) =>
        item.map((res) => {
          if (res.id == order.id) {
            res.loading = false;
          }
          return res;
        }),
      );
    }
  };
  // // 查看订阅
  // const handleViewSubscription = async (item) => {
  //   item.loading = true;
  //   try {
  //     const res = await infoController.orderManage();
  //     if (res?.code === 0) {
  //       console.log(res, 'success');
  //       window.open(res.data.url);
  //     }
  //   } catch (error) {
  //     console.log(error);

  //     message.error('Network error, please try again', {
  //       id: 'only',
  //     });
  //   }
  //   item.loading = false;
  // };
  const handleToggle = (val) => {
    setPricingChecked(val);
  };
  return (
    <div className="pricingbox">
      <div className="pricingbox_main">
        {/* {token ? <PricingPopUpHead /> : <PricingPageHead />} */}
        <PricingPopUpHead />
        <div className="title">{t('As_Pricing_Title')}</div>
        <div className="subtitle">{t('As_Pricing_TitleDesc')}</div>
        <div role="tablist" className="tabs tabs-lift meanlist">
          {mean.map((item, index) => (
            <span
              role="tab"
              onClick={() => handleToggle(index)}
              className={pricingChecked == index ? 'tab tab-active' : 'tab'}
              key={index}>
              {t(item)}
            </span>
          ))}
        </div>
        <div className="saved">
          {t('As_Pricing_NewSaving')}
          <span> 16%</span>
        </div>

        <div className={`price_main ${pricingChecked == 2 ? 'fuelbags_main' : ''}`}>
          {pricingChecked < 2
            ? textlist.map((res, index) => (
                <div className={`price_item ${index == 2 && 'recommend'}`} key={index}>
                  {index == 2 && <span className="goods_title">{t('As_Pricing_Popular')}</span>}
                  <div className={`goods ${index != 2 && 'common'}`}>
                    <div className="goods_name">{t(sub_info[index].level)}</div>
                    {res.id == 4 ? (
                      <div className="goods_price">{t('As_Pricing_Talk')}</div>
                    ) : (
                      <div className="goods_price">
                        <div className="price">
                          ${pricingChecked == 0 ? res.monthlyFee : res.annualFee / 12}
                          <span className="util">{t('As_Pricing_Month')}</span>
                        </div>
                        <div className="point">
                          {res.giftPoint}
                          <span className="util_point"> {t('As_Pricing_Credits')}</span>
                        </div>
                      </div>
                    )}
                    {/* 购买按钮 */}
                    <PricingButton
                      user={{ level: userData.subscription?.id, type: userData.asAnnualFee }}
                      pricing={{ level: res.id, type: pricingChecked == 1 }}
                      loading={res.loading}
                      onPay={() => handleCheckout(0, res, pricingChecked)}
                    />
                    <div className="equity">
                      {sub_info[index].creditCanBeUsedFor.map((res, index) => (
                        <div className={`tip_item ${index == 0 ? 'tip' : ''}`} key={index}>
                          {index > 0 && <img src={hold} alt="" className="get_img" />}
                          <span>{t(res)}</span>
                        </div>
                      ))}
                    </div>
                    <ul className="desc">
                      {sub_info[index].equityDetails.map((res, index) => (
                        <li className={`tip_item ${index == 0 ? 'tip' : ''}`} key={index}>
                          {index > 0 && <span className="dot" />}
                          <span>{t(res)}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))
            : fuelbags.map((res, index) => (
                <div
                  className={`price_item fuelbags ${index == 2 ? 'recommend_bage' : ''}`}
                  key={index}>
                  <div className="bags_price">
                    <div className="credits">
                      {res.number}
                      <span className="util"> {t('As_Pricing_Credits')}</span>
                    </div>
                    <div className="price">${res.price}</div>
                  </div>
                  <button
                    className="btn btn-primary pricing_button purchase no-animation"
                    onClick={() => handleCheckout(1, res)}>
                    {res.loading && <span className="loading loading-spinner loading-md"></span>}
                    {t('As_Pricing_CTAButton3')}
                  </button>
                  <div>
                    {fuelbag_info[index].map((res, index) => (
                      <div className={`tip_item ${index == 0 ? 'tip' : ''}`} key={index}>
                        {index > 0 && <span className="dot" />}
                        <span>{t(res)}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
        </div>
        {pricingChecked < 2 && (
          <>
            <div className="table_title">{t('As_Pricing_CompareTitle')}</div>
            <div className="looktable">
              <div className="tableshow">
                <table className="table">
                  <thead>
                    <tr>
                      <th></th>
                      <th className="table_th">{t('As_Pricing_Plan1')}</th>
                      <th className="table_th">{t('As_Pricing_Plan2')}</th>
                      <th className="table_th">{t('As_Pricing_Plan3')}</th>
                      <th className="table_th">{t('As_Pricing_Plan4')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {features_table.map((res1, index) => (
                      <tr key={index}>
                        {res1.map((res2, index) => (
                          <td key={index}>
                            {res2.type ? <img src={res2.value} /> : t(res2.value)}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// function PricingPageHead() {
//   const navigate = useNavigate();
//   const handleTopage = (val) => {
//     navigate(val);
//   };
//   const handleTotalecast = () => {
//     location.href = 'https://www.talecast.ai';
//   };
//   return (
//     <div className="pricing_page_head_box">
//       <img src={logo} className="iocnlogo" alt="" onClick={handleTotalecast} />
//       <div className="btnbox">
//         <div
//           className="loginbtn"
//           onClick={() => {
//             handleTopage('/login');
//           }}>
//           Log in
//         </div>
//         <button
//           className="btn btn-active btn-primary signbtn"
//           onClick={() => {
//             handleTopage('/signup');
//           }}>
//           Sign up
//         </button>
//       </div>
//     </div>
//   );
// }

function PricingPopUpHead() {
  const { isOpen, setIsOpen } = useDrawer();
  const navigate = useNavigate();
  const handleClosepage = () => {
    if (window.location.pathname === '/pricing') {
      navigate('/home');
    }
    setIsOpen(false);
  };
  const [showClose, setShowClose] = useState(false);

  useEffect(() => {
    if (isOpen || window.location.pathname === '/pricing') {
      const timer = setTimeout(() => {
        setShowClose(true);
      }, 500);
      return () => clearTimeout(timer);
    } else {
      setShowClose(false);
    }
  }, [isOpen]);

  return (
    <div className="pricing_popup_head_box">
      {showClose && <img src={logo} className="iocnlogo" alt="" />}
      {showClose && (
        <Icon name="icon-close-stroke" onClick={handleClosepage} className="iconclose" />
      )}
    </div>
  );
}
function PricingButton({ user, pricing, loading, onPay }) {
  const { t } = useTranslation();
  return (
    <>
      {pricing.level == 4 ? (
        // let`s talk
        <button
          className="btn btn-neutral pricing_button no-animation"
          onClick={() => {
            window.open(
              'https://docs.google.com/forms/d/e/1FAIpQLScBaS1yTVtpE-gKVkCYteKhQF1KZKPR2Hfldhqfg_C-vjld5w/viewform?usp=sharing',
              '_black',
            );
          }}>
          {t('As_Pricing_CTAButton2')}
        </button>
      ) : user.level == pricing.level && (pricing.level == 1 || user.type == pricing.type) ? (
        // 用户等级等于商品等级并且为免费套餐、 用户等级等于商品等级并且类型相同
        <button className="btn pricing_button pricing_now no-animation">
          {t('As_Pricing_Current')}
        </button>
      ) : (user.level == pricing.level && !pricing.type) || user.level > pricing.level ? (
        // 用户等级等于商品等级并且商品类型为月，用户等级大于商品等级
        <div className="pricing_button"></div>
      ) : (user.level == pricing.level && pricing.type) || user.level < pricing.level ? (
        // 用户等级等于商品等级并且商品类型为年，用户等级小于商品等级
        <button
          className={`btn btn-primary pricing_button pricing_up no-animation ${pricing.level === 3 && 'special'}`}
          onClick={onPay}>
          {loading && <span className="loading loading-spinner loading-md"></span>}
          {t('As_Pricing_CTAButton1')}
        </button>
      ) : window.location.pathname === '/pricing' ? (
        <button
          className={`btn btn-primary pricing_button pricing_up no-animation ${pricing.level === 3 && 'special'}`}
          onClick={onPay}>
          {loading && <span className="loading loading-spinner loading-md"></span>}
          {t('As_Pricing_CTAButton1')}
        </button>
      ) : (
        <div className="pricing_button"></div>
      )}
    </>
  );
}
